import React from "react";

export default function Loader({ size = 4, noAnimation = true }) {
  // Versione senza animazione (default)
  if (noAnimation) {
    return (
      <div className="inline-block text-primary font-bold">
        ...
      </div>
    );
  }
  
  // Versione con animazione (non usata per default)
  return (
    <div className="inline-block">
      <div 
        className={`rounded-full border-2 border-t-transparent border-primary`}
        style={{ width: `${size * 0.25}rem`, height: `${size * 0.25}rem` }}
      ></div>
    </div>
  );
}